require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-double-parc-de-la-villette.json") })
        }
      }, "path---project-double-parc-de-la-villette");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-double-parc-de-la-villette!./.cache/json/project-double-parc-de-la-villette.json
// module id = 343
// module chunks = 231608221292675